module.exports = __webpack_public_path__ + "img/fig08.9ec13a2a.jpg";